export default __webpack_public_path__ + "1f9f27b85d815afbd576f338cf3ed6a3.png";